import * as braze from "@braze/web-sdk";
const pendingCustomEvents = [];
/**
 * Dispatch an event to Braze.
 *
 * Although this won't actually send the event unless Braze is initialised,
 * otherwise it just queues it up internally. It expects that the brazeInitialise()
 * function will call sendPendingEvents() when Braze is actually initialised.
 */
export function trackCustomEvent(eventName, attributes) {
    if (braze.isInitialized()) {
        braze.logCustomEvent(eventName, attributes);
    }
    else {
        enqueueBrazeCustomEvent(eventName, attributes);
    }
}
function enqueueBrazeCustomEvent(eventName, attributes) {
    pendingCustomEvents.push({ name: eventName, attributes: attributes });
}
export function sendPendingEvents() {
    while (pendingCustomEvents.length > 0) {
        const event = pendingCustomEvents.shift();
        if (event) {
            braze.logCustomEvent(event.name, event.attributes);
        }
    }
}
